module.exports = __webpack_public_path__ + "img/source04_02.4b3b02a0.png";